import React from 'react';
import '../styles/FeatureCard.css';

const FeatureCard = ({ feature }) => (
  <div className="feature-card">
    <h3 className="feature-title">{feature.title}</h3>
    <p className="feature-description">{feature.description}</p>
    <div className="feature-divider"></div>
    <a href={feature.href} className="feature-link">
      Read More
    </a>
  </div>
);

export default FeatureCard;
